export default function PrivacyPage() {
  return (
    <div className="px-4 md:px-5" style={{ direction: 'rtl', maxWidth: 900, margin: '0 auto', paddingTop: 40, paddingBottom: 40, fontFamily: 'sans-serif', lineHeight: 1.8, color: '#333' }}>
      <h1>מדיניות הפרטיות</h1>
      <p><strong>אחרון עודכן: מרץ 2026</strong></p>

      <h2>1. מבוא</h2>
      <p>אנחנו מתחייבים להגן על פרטיותך. דף זה מסביר כיצד אנו אוספים, משתמשים, וחוסים מידע.</p>

      <h2>2. אילו נתונים אנו אוספים</h2>
      <ul>
        <li>שם, טלפון, אימייל</li>
        <li>נתוני תרומות (סכום, תאריך, שם קמפיין)</li>
        <li>פעילות מתנדב (שעות, מיומנויות)</li>
        <li>יומנים גישה ו-IP (ללא זיהוי אישי)</li>
      </ul>

      <h2>3. כיצד אנו משתמשים בנתונים</h2>
      <ul>
        <li>לעיבוד תרומות וקבלות</li>
        <li>לניהול פעילויות מתנדבים</li>
        <li>לשלוח עדכונים וביולטינים (בהסכמתך בלבד)</li>
        <li>לשיפור השירות</li>
      </ul>

      <h2>4. שמירה וביטחון</h2>
      <p>אנו מאחסנים נתונים בשרתים מאובטחים עם הצפנה TLS. גישה מוגבלת לאנשי צוות מורשה בלבד.</p>

      <h2>5. זכויות המשתמש</h2>
      <ul>
        <li><strong>גישה:</strong> בקש את כל הנתונים שלך</li>
        <li><strong>תיקון:</strong> עדכן או תקן נתונים שגויים</li>
        <li><strong>מחיקה:</strong> בקש מחיקה מלאה של נתונים (שקול זכויות משפטיות)</li>
        <li><strong>ייצוא:</strong> קבל עותק של הנתונים שלך בפורמט טקסט</li>
      </ul>

      <h2>6. שיתוף צדדים שלישיים</h2>
      <p>
        <strong>החברה מתחייבת שלא להעביר את פרטי הלקוח לצד שלישי</strong>,
        ולא למכור, להשכיר או לסחור במידע אישי. השיתוף היחיד המותר הוא:
      </p>
      <ul>
        <li>
          <strong>ספקי סליקת אשראי מורשים</strong> (Tranzila ו-HyP) — אך ורק
          לצורך ביצוע עסקת התשלום, בהתאם לתקן PCI-DSS.
        </li>
        <li>
          <strong>הארגון המוטב</strong> (העמותה לה הועברה התרומה) — לצורך
          הנפקת קבלה רשמית והכרה בתורם.
        </li>
        <li>
          <strong>רשויות אכיפה ובתי משפט</strong> — אך ורק כאשר נדרש לכך
          במפורש על פי דין.
        </li>
      </ul>

      <h2>7. עוגיות וקביעות מעקב</h2>
      <p>אנו משתמשים בעוגיות בסיסיות להתחברות. אנו לא משתמשים בעוגיות מעקב של צד שלישי.</p>

      <h2>8. שינויים למדיניות</h2>
      <p>עדכונים לדף זה יהיו פתוחים. שימוש רציף באתר פירושו הסכמה לשינויים.</p>

      <h2>9. שימוש ב-Google Workspace APIs (Limited Use)</h2>
      <p>
        השימוש שלנו בנתוני משתמש המתקבלים מ-Google Workspace APIs (לרבות Google Calendar)
        עומד ב-<a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer">Google API Services User Data Policy</a>,
        כולל דרישות ה-Limited Use. אנחנו לא מוכרים נתונים אלה, לא משתמשים בהם לפרסום,
        ולא מאפשרים גישה אליהם לבני אדם פרט למקרים המותרים על-פי המדיניות (בהסכמה מפורשת
        של המשתמש, לצורך תפעול ואבטחה, או כנדרש על-פי חוק).
      </p>
      <p style={{ direction: 'ltr', textAlign: 'left', background: '#f5f5f5', padding: '12px 14px', borderRadius: 8, marginTop: 8 }}>
        <em>
          The use of raw or derived user data received from Workspace APIs will adhere to the
          Google User Data Policy, including the Limited Use requirements.
        </em>
      </p>

      <h2>10. צור קשר</h2>
      <p>
        בכל שאלה בנושא פרטיות, או למימוש זכויות לפי סעיף 5 לעיל, ניתן לפנות אלינו:
      </p>
      <p>
        <strong>Y.Sh כלכלה וצריכה חברתית בע&quot;מ</strong> (ח.פ. 516866514)
        <br />
        עציון 27, פרדס חנה
        <br />
        טלפון: <a href="tel:0538286227">053-828-6227</a>
        <br />
        דוא&quot;ל: <a href="mailto:support@amutech.co.il">support@amutech.co.il</a>
      </p>
    </div>
  );
}
